import debounce from 'lodash/debounce';
import { component } from 'picoapp';
import { changeItem } from '../../js/lib/cart'; // eslint-disable-line

export default component((node) => {
  /**
   * Data + elements
   */
  const decreaseBtn = node.querySelector('.js-decreaseBtn');
  const increaseBtn = node.querySelector('.js-increaseBtn');
  const qtyInput = node.querySelector('.js-qtyInput');
  const removeBtn = node.querySelector('.js-removeBtn');

  const config = JSON.parse(node.dataset.config);
  const { key } = config;

  /**
   * Functions
   */
  const updateQty = (qty) => {
    changeItem({
      key,
      quantity: qty,
    });
  };

  const clickQtyBtn = (updatedQty) => {
    qtyInput.value = updatedQty;
    qtyInput.dispatchEvent(new Event('change'));
  };

  const removeItem = () => {
    removeBtn.classList.add('cart-item__remove-button--active');
    updateQty(0);
  };

  const init = () => {
    qtyInput.addEventListener('change', debounce(() => updateQty(qtyInput.value), 500));
    decreaseBtn.addEventListener('click', () => clickQtyBtn(Math.max(parseInt(qtyInput.value, 10) - 1, 0)));
    increaseBtn.addEventListener('click', () => clickQtyBtn(parseInt(qtyInput.value, 10) + 1));

    removeBtn.addEventListener('click', removeItem);
  };

  /**
   * Init
   */
  init();
});
